import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import FeedExplorer from './components/FeedExplorer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/:slug" element={<FeedExplorer />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
